// @owners { team: patients }
import { queries } from '~shared/queries/query-keys';
import { useQuery } from '~shared/react-query';
import { onboardingBackgroundColor } from '../helpers/onboardingBackgroundColor';

export const useQueryMedicalInfoConfigs = () => {
  const { isFetching, isError, isSuccess, data } = useQuery({
    ...queries.onboardingConfigs.fetchMedicalInfo({ params: {} }),
  });

  const partnershipName = data?.data?.partnership_name;
  const headerBackgroundColor = onboardingBackgroundColor();

  return {
    partnershipName,
    headerBackgroundColor,
    headerLogoUrl: data?.data?.header_logo_url,
    isFetching,
    isError,
    isSuccess,
  };
};
